<template>
  <div id="contenedor-infraestructura-configuracion-subtipos-infraestructura-desktop">
    <v-data-table
      :headers="headers"
      :items="listadoSubtiposInfraestructura">
      <template v-slot:[`item.acciones`]="{ item }">
        <opciones :subtipoInfraestructura="item"></opciones>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import Opciones from './Opciones.vue';

export default {
  name: 'InfraestructuraConfiguracionSubtiposInfraestructuraDesktop',
  props: {
    listadoSubtiposInfraestructura: {
      type: Array,
      required: true,
    },
  },
  components: {
    Opciones,
  },
  data() {
    return {
      headers: [
        { text: 'Subtipo de Infraestructura', sortable: false, value: 'descripcion' },
        { text: 'Tipo', value: 'tipoInfraestructura.descripcion' },
        {
          text: '', align: 'end', sortable: false, value: 'acciones',
        },
      ],
    };
  },
};
</script>

<style lang="scss">

</style>
